<!-- 企业级-业务领域-仓储业务-库位管理 -->
<template>
  <div class="mainArea CDeviceBind">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-input class="searchInput" placeholder="设备号" v-model="keyword.deviceId" clearable></el-input>
          <el-cascader
          v-model="keyword.space_id"
          :options="spaceData"
          placeholder="选择空间"
          :props="cascaderProps"
          :show-all-levels="false"
          clearable></el-cascader>
          <el-button class="searchBtn" type="primary">搜 索</el-button>
        </div>
        <!-- 添加客户信息 -->
        <div class="addButton">
          <el-button type="primary" @click="openDio('add')">绑定</el-button>
          <el-button type="warning" @click="openDio('batch')">批量解绑</el-button>
        </div>

        <el-table v-loading="loading" :data="wareData" style="width: 100%" @selection-change="tableChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column type="index" width="80" label="序号"></el-table-column>
          <el-table-column prop="" label="设备名称"></el-table-column>
          <el-table-column prop="" label="设备ID"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button type="text">修改</el-button> -->
              <el-button type="text">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="wareDio" :width="dioWidth" class="configDio wareDio" center>
        <template v-if="dioType == 'add'">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="dioform" label-width="90px">
            <el-form-item label="设备名称:" prop="wareName">
              <el-select v-model="dioform.deviceId">
                <el-option label="设备1" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型:">
              <el-input v-model="dioform.deviceType" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="submitWare('form')">确认</el-button>
          <el-button @click="wareDio = false">取消</el-button>
        </span>
        </template>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { expSceneApi } from "../../../../../static/js/exp/scene.js"

  export default {
    name: 'CStorehouse',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        //搜索
        keyword:{
          deviceId:'',//设备ID
          space_id:'',//空间ID
        },
        spaceData:[],//空间数据
        cascaderProps:{
          label:'space_name',
          value:'space_id',
          expandTrigger: 'hover',
          checkStrictly:true,
        },

        loading:false,
        wareData:[{
          aa:''
        }],//仓库数据

        //分页
        curr:1,
        limits:10,
        total:0,

        wareDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        dioform:{
          deviceId:'',//设备ID
          deviceType:'',//设备类型
          checkData:[],//库位数据
        },

        rules:{
          wareName:[
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
          ],
          shelves:[
            { required: true, message: '请输入仓库地址', trigger: 'blur' },
          ],
        },
      };
    },
    mounted(){
      
    },
    created: async function () {
      this.getSpaceInfo(this.$route.query.space_id)
    },
    methods: {
      //表格选中
      tableChange(val) {
        console.log(val)
      },
      // 获取空间详情
      async getSpaceInfo(space_id) {
        let that = this
        
        let data = {
          space_id: space_id=='-2'? 0 : space_id
        }
        let res = await expSceneApi.getSpaceInfo(data)
        console.log('res',res.data)
        that.spaceData = res.data.children
        
      },

      //打开弹窗
      openDio(type){
        this.dioType = type
        if(type == 'add'){
          this.dioTitle = '添加设备'
          this.dioWidth = '700px'
        }else if(type == 'edit'){
          this.dioTitle = '修改'
          this.dioWidth = '700px'
        }
        this.wareDio = true
      },
      //弹窗确认
      submitWare(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            
          } else {
            return false;
          }
        });
      },

      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CDeviceBind{
  .w200{
    width: 200px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }

  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CWarehouseManage/CDeviceBind.vue